import { useMemo } from "react";
import { usePlayerEconomy } from "../src/stores/usePlayerEconomy";

const COIN_ICON_PATH = "M12 2C6.48 2 2 4.69 2 8v8c0 3.31 4.48 6 10 6s10-2.69 10-6V8c0-3.31-4.48-6-10-6zm8 6c0 2.21-3.58 4-8 4S4 10.21 4 8s3.58-4 8-4 8 1.79 8 4zm0 4.09c0 2.21-3.58 4-8 4s-8-1.79-8-4V10c1.8 1.52 4.9 2.46 8 2.46s6.2-.94 8-2.46v2.09zm0 4c0 2.21-3.58 4-8 4s-8-1.79-8-4v-1.97c1.84 1.4 4.92 2.24 8 2.24s6.16-.84 8-2.24V16.09z";

export default function PlayerCoinsHUD() {
  const coins = usePlayerEconomy((state) => state.coins);

  const formattedCoins = useMemo(() => {
    if (Number.isNaN(coins)) {
      return "0";
    }

    return coins.toLocaleString(undefined, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }, [coins]);

  return (
    <div className="player-coins">
      <div className="player-coins__container" aria-label={`Monedas disponibles: ${formattedCoins}`} role="status">
        <svg className="player-coins__icon" viewBox="0 0 24 24" width="24" height="24" aria-hidden="true">
          <path d={COIN_ICON_PATH} />
        </svg>
        <span className="player-coins__label">x {formattedCoins}</span>
      </div>
    </div>
  );
}
